import React, { useState } from 'react'
import PageBanner from "app/components/ui/PageBanner"
import SiteGrid from "app/components/ui/SiteGrid"
import HelmetTitle from "app/meta/HelmetTitle"
import './styles/BlogPage.css'
import { blogsArray, sortByOptions } from 'app/data/blogData'
import Avatar from "app/components/ui/Avatar"
import { useTeamMember } from "app/hooks/teamHooks"
import { showXResultsOptions } from "app/data/generalData"
import { convertClassicDate } from "app/utils/dateUtils"
import { AppInput, AppReactSelect } from "app/components/ui/AppInputs"
import { doctorsArray } from "app/data/teamData"
import { Link } from "react-router-dom"
import AppButton from "app/components/ui/AppButton"

export default function BlogPage() {

  const limitsNum = 5
  const [searchString, setSearchString] = useState('')
  const [sortBy, setSortBy] = useState(sortByOptions[0].value)
  const [showMaxResults, setShowMaxResults] = useState(showXResultsOptions[1].value)
  const clean = text => text.replace(/[^a-zA-Z0-9 ]/g, "")
  let pattern = new RegExp('\\b' + clean(searchString), 'i')

  const blogsArrayFiltered = blogsArray?.filter(blog => {
    return pattern.test(blog.title)
      || pattern.test(doctorsArray.find(member => member.id === blog.authorID)?.name)
  })

  const blogsList = blogsArrayFiltered
    ?.sort((a, b) => {
      if (sortBy === 'date-asc') {
        return a.date.getTime() - b.date.getTime()
      } else if (sortBy === 'views-desc') {
        return b.views - a.views
      } else if (sortBy === 'views-asc') {
        return a.views - b.views
      } else {
        return b.date.getTime() - a.date.getTime()
      }
    })
    .slice(0, showMaxResults)
    .map((blog, index) => {
      return <BlogCard
        key={index}
        blog={blog}
      />
    })

  return (
    <div className="blog-page">
      <HelmetTitle title="Blog" />
      <PageBanner
        title="Blog"
        subtitle="healthcare in Focus: Discover the Latest Trends and Developments in Our Blog"
      />
      <div className="page-content">
        <SiteGrid>
          <h4 className="page-title">Articles ({blogsArrayFiltered.length})</h4>
          <div className="blog-toolbar">
            <div className="left">
              <AppInput
                placeholder="Search..."
                value={searchString}
                onChange={(e) => setSearchString(e.target.value)}
                iconright={
                  <div className="icon-container">
                    <i className="far fa-search" />
                  </div>
                }
              />
            </div>
            <div className="right">
              <AppReactSelect
                placeholder={`Show ${showMaxResults} results`}
                options={showXResultsOptions}
                value={showMaxResults}
                onChange={(results) => setShowMaxResults(results.value)}
              />
              <AppReactSelect
                placeholder={`Sort by ${sortByOptions.find(option => option.value === sortBy)?.label}`}
                options={sortByOptions}
                value={sortBy}
                onChange={(sort) => setSortBy(sort.value)}
              />
            </div>
          </div>
          <div className="blog-grid">
            {blogsList}
          </div>
          <div className="btn-group">
            {
              blogsArrayFiltered.length > showMaxResults ?
                <AppButton
                  label="Load more"
                  onClick={() => setShowMaxResults(showMaxResults + limitsNum)}
                /> :
                <small>You have reached the end of the list.</small>
            }
          </div>
        </SiteGrid>
      </div>
    </div>
  )
}

export const BlogCard = ({ blog }) => {

  const author = useTeamMember(blog.authorID)

  return author && blog ? (
    <Link
      to={`/blog/${blog.id}`}
      className="blog-card"
    >
      <div className="blog-img">
        <img
          src={blog.img}
          alt={blog.title}
        />
      </div>
      <div className="info-content">
        <h5>{blog.title}</h5>
        <div className="author">
          <Avatar
            src={author.img}
            dimensions={33}
            alt={author.name}
          />
          <h6>{author.name}</h6>
        </div>
        <div className="meta">
          <small>
            <i className="fas fa-calendar-alt" />
            {convertClassicDate(blog.date)}
          </small>
          <small>
            <i className="fas fa-eye" />
            <span>{blog.views}</span>
          </small>
        </div>
      </div>
    </Link>
  ) :
    null
}